module.exports = __webpack_public_path__ + "b5b11f8a3ecc7c644e0edd67124fba92.svg";